<div class="business-highlights w-full card-bg duration-200 rounded-lg p-6 relative">
  <!-- Header with Title and Tabs/Selection -->
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-lg font-medium text-[#141437] dark:text-white uppercase">{{ title }}</h2>
    
    <!-- For Highlights: Toggle Buttons -->
    @if (dataType === 'highlights') {
      <app-toggle-btns
        [headerOptions]="{ 
          showlabels: true, 
          showIcon: false, 
          showToggleButton: true, 
          toggleOptions: tabOptions, 
          showTable: activeTab === 'droppers' 
        }"
        [activeValue]="activeTab"
        (viewChanged)="onTabChange($event)">
      </app-toggle-btns>
    }
    
    <!-- For Industries: Selection Component -->
    @if (dataType === 'industries') {
      <div class="w-auto">
        <app-selection
          [mode]="'single'"
          [options]="industryOptions"
          [name]="'industrySelector'"
          [size]="'md'"
          [variant]="'default'"
          [orientation]="'horizontal'"
          [fullWidth]="false"
          (valueChange)="onIndustryChange($event)">
        </app-selection>
      </div>
    }
  </div>

  @if (currentChartData.length > 0) {
    <!-- Legend -->
    <div class="flex gap-6 mb-6">
      <div class="flex items-center gap-2">
        <span class="w-4 h-4 rounded-sm bg-purple-600 dark:bg-purple-500"></span>
        <span class="text-sm font-medium text-slate-700 dark:text-slate-300">Previous Period</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="w-4 h-4 rounded-sm bg-indigo-600 dark:bg-indigo-400"></span>
        <span class="text-sm font-medium text-slate-700 dark:text-slate-300">Current Period</span>
      </div>
    </div>

    <!-- Chart Container -->
    <div class="chart-wrapper h-[500px] w-full">
      <app-highlight-chart
        [chartData]="currentChartData"
        [chartType]="'lineChart'"
        [formatCurrency]="false"
        [currentPeriod]="currentPeriod"
        [previousPeriod]="previousPeriod">
      </app-highlight-chart>
    </div>
  } @else if (!isLoading()) {
    <!-- Empty State -->
    <div class="flex flex-col items-center justify-center h-[500px] w-full text-gray-500 bg-gray-50/30 dark:bg-slate-800/10 rounded-xl border border-dashed border-gray-200 dark:border-slate-700 mt-4">
      <app-icon-v2 name="Inbox" [size]="64" customClass="text-gray-300 dark:text-gray-600 mb-4"></app-icon-v2>
      <p class="text-lg font-medium text-gray-600 dark:text-gray-300">No data available for this selection</p>
      <p class="text-sm text-gray-400 dark:text-gray-500 mt-1 uppercase tracking-wider">Try changing the date range, currency or categories</p>
    </div>
  }
      @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
</div>
